import { BackTop } from "ant-design-vue";
const { ...other } = BackTop;
const YwBackTop = {
  ...other,
  name: "YwBackTop",
};

YwBackTop.install = function (Vue) {
  Vue.component(YwBackTop.name, YwBackTop);
};

export default YwBackTop;